import {IconType, NavigationItemModel} from './navigation-item.model';
import {Const} from "../../../helpers/Const";

export const NAVIGATION_ITEMS: NavigationItemModel[] = [
    {
        title: "Organization Explorer",
        icon: "sitemap",
        iconType: IconType.FontAwesome,
        route: "project/_all/organizations",
    },
    {
        title: "Cloud Automation Designer",
        icon: "/assets/cloud-automation-designer/icons/cad-icon.svg",
        iconType: IconType.CAD,
        route: "cloudAutomationDesigner"
    },
    {
        title: "Resource Event Viewer",
        icon: "clock-rotate-left",
        iconType: IconType.FontAwesome,
        route: "events"
    }
];
